module.exports = __webpack_public_path__ + "img/user.620f9706.svg";